module.exports = __webpack_public_path__ + "img/historial-participacion.f51a3828.png";